export default {
    patient: null,
    patientsAndOwners: [],
    owner: null,
    prescriptions: null
}